import React from 'react';
import T from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { Container, SvgContainer } from './style';

type Layout = 'default' | 'contain';

interface SpinnerProps {
  layout?: Layout;
  style?: React.CSSProperties;
}

const Spinner: React.FC<SpinnerProps> = ({ layout, style }) => (
  <ThemeProvider theme={{ layout }}>
    <Container style={style}>
      <SvgContainer viewBox="0 0 50 50">
        <circle className="path" cx="25" cy="25" fill="none" r="20" strokeWidth="5" />
      </SvgContainer>
    </Container>
  </ThemeProvider>
);

Spinner.defaultProps = {
  layout: 'default',
  style: {},
};

Spinner.propTypes = {
  layout: T.oneOf<Layout>(['default', 'contain']),
  style: T.object,
};

export default Spinner;
